<template>
    <div class="block-boy">
        <p class="block-boy__text block-boy__text-one">
            Всего через год ребенок делает свои первые шаги. У него проявляется любимое развлечение на улице. Теперь это не сон, а игры и общение на детской площадке.
        </p>
        <BlockParallax
            fixed
            speed="10"
            direction="top"
            transform="translateY"
            class="block-boy__img--mobile"
        >
            <img
                srcset="../assets/2-img.jpg, ../assets/2-img@2x.jpg 2x"
                src="../assets/2-img.jpg"
                class="block-boy__img block-boy__img block-boy__img-one"
            />
        </BlockParallax>
        <p class="block-boy__text block-boy__text-two">
            Хорошо если есть не просто качели и песочница «Гриб», а целый игровой город. Пример — <a href="https://pikabu.ru/story/bubm_rna_t_vozvceq_v_ceqya_eniobre_sgychchm_r_2009592" class="app__link app__link--red" target="_blank">плейхаб «Пирамиды»</a>, в котором сочетаются разный ландшафт, грунт и объекты для игры. Комплекс разработан в Германии и, что особенно важно, отвечает всем требования безопасности. Можно и побегать за мячиком, и попрыгать на батуте, и показаться на своем игрушечном мерседесе.
        </p>

        <BlockParallax
            class="block-boy__img-box"
            fixed
            speed="8"
            offset="350"
            direction="top"
            transform="translateY"
        >
            <img
                srcset="../assets/3-img.jpg, ../assets/3-img@2x.jpg 2x"
                src="../assets/3-img.jpg"
                class="block-boy__img block-boy__img-two"
            />
            <div class="image-caption">Детская площадка PlayHub в проекте «Бунинские луга»</div>
        </BlockParallax>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'
export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
.block-boy {
    display flex
    flex-direction column
    +layout-md-and-up() {
        position relative
        margin-top -7rem
    }
    &__text {
        margin 2rem 0 0 0
        font-size 1.5rem
        line-height 1.47
        letter-spacing 0.16px
        color $color-text
        padding-left 5rem
        +layout-md-and-up() {
            max-width 45rem
            padding-left: 8rem
        }
        +layout-l-and-up() {
            max-width 43.4rem
        }
    }
    &__text-one {
        +layout-md-and-up() {
        order: 1
        }
    }
    &__text-two {
        margin-top 2.6rem
        +layout-md-and-up() {
            order: 2
        }

    }
    &__img {
        &--mobile {
            +layout-xs() {
                text-align right
            }
        }
    }
    &__img-one {
        margin-top 3rem
        width: calc(100% - 1rem)
        margin-right: -2rem
        margin-left: auto
        +layout-sm-and-up() {
            width auto
        }
        +layout-md-and-up() {
            order 3
            position: absolute
            top: 0
            right: 2rem
            margin-top 0
        }
    }
    &__img-box {
        margin-top 2.5rem
        margin-left -1rem
        margin-right -1rem
        +layout-sm-and-up() {
            width auto
        }
        +layout-md-and-up() {
            order 4
            margin-left 0
            margin-right 0
            max-width 62rem
        }
    }
    &__img-two {
        object-fit cover
        width 100%
        max-width 100%
        +layout-md-and-up() {
            position: relative
            z-index 5
            max-width 62.5rem
            margin-top 3.7rem
        }
    }
}
</style>
